import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './Short.html';
import { ShortModel } from './ShortModel';
import ShortService from './ShortService';
import { Toaster } from '../../Services/toast';
import UserService from '../../shared/userService/UserService';
import UserRoleService from '../../shared/userService/UserRoleService';
import OperatorService from '@/Services/OperatorService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        ShortService,
        UserService,
        UserRoleService,
        OperatorService
    ],
})
export default class Short extends Vue {
    @Inject(ShortService) public shortService!: ShortService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(OperatorService) public operatorService!: OperatorService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public shortCodeId: string = '0';
    public operatorId: string = '0';
    public name: string = '0';
    public User: any;
    public userRole: any;
    public operatorOptions: any[] = [];
    public otpDialog: boolean = false;
    public deleteConfirmDialog: boolean = false;
    public disconnectDialog: boolean = false;
    public disconnectShortCodeId: string = '';
    public otpCode: string = '';
    private timerHandle: any = null;
    public countDown: number = 0;
    public data: string = '';
    public otpExpiresAt: string = '';

    public headers: any[] = [];

    public shorts: ShortModel[] = [];
    public shortsCount: number = 0;
    public filterShorts: ShortModel[] = [];
    public filterModel: any = {
        id: '',
        operator: '',
        name: '',
        providerId: '',
    };
    public async created() {

        const response = await this.operatorService.getAll();
        if (response.isSuccess) {
            this.operatorOptions = response.result;
        }

        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        this.buildTableHeaders();
        this.$emit('childinit', this.layoutSup);
    }
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }

    public buildTableHeaders() {
        const cols: any[] = [
            { text: this.$t('shortPage.company'), value: 'operatorId', align: 'center', sortable: false },
        ];
        if (this.userRole === 9 || this.userRole === 5 || this.userRole === 2) {
            cols.push({
                text: this.$t('shortPage.providerName'),
                value: 'providerName',
                align: 'center',
                sortable: false,
            });
        }
        cols.push(
            {
                text: this.$t('shortPage.shortCode')
                    + ' / ' +
                    this.$t('shared.customerId'),
                value: 'name',
                align: 'center',
                sortable: false,
            },
            {
                text: this.$t('shortPage.shortcodeType'),
                value: 'shortCodeType',
                align: 'center',
                sortable: false,
            },
            { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
        );
        this.headers = cols;
    }

    public async mounted() {
        const response = await this.shortService.get(this.filterModel.operator,
            this.filterModel.name, '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.shorts = response.result;
        this.shortsCount = response.totalCount;
    }
    @Watch('filterModel', { deep: true })
    public async search() {
        const response = await this.shortService.get(this.filterModel.operator.toString(),
            this.filterModel.name, '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.shorts = response.result;
        this.shortsCount = response.totalCount;
    }

    public getOperatorText(operatorId: number): string {
        const operator = this.operatorOptions.find(op => op.id === operatorId);
        return operator ? operator.name : '-';
    }

    /** API may use camelCase or PascalCase; avoid ?? (not transpiled by current babel chain). */
    public getProviderNameForRow(item: any): string {
        if (!item) {
            return '-';
        }
        const v = item.providerName != null && item.providerName !== ''
            ? item.providerName
            : item.ProviderName;
        if (v == null || String(v).trim() === '') {
            return '-';
        }
        return String(v).trim();
    }

    public getShortCodeType(type: number) {
        switch (type) {
            case 1:
                return this.$t('White List').toString();
            case 2:
                return this.$t('Black List').toString();
            default:
                return '-';
        }
    }

    public isEqual(value1: string | null, value2: string) {
        return (value1 === '' || value1 === null || value1 === undefined || value2.includes(value1));
    }

    public onDeleteClick(id: string, name: string) {
        this.shortCodeId = id;
        this.name = name;
        this.showDeleteConfirmDialog();
    }

    public showDeleteConfirmDialog() {
        this.deleteConfirmDialog = true;
    }

    public hideDeleteConfirmDialog() {
        this.deleteConfirmDialog = false;
    }

    /** Yes on confirm: keep existing OTP delete flow. */
    public confirmDeleteShortCode() {
        this.hideDeleteConfirmDialog();
        this.sendDeleteOtp();
    }

    /** Disconnect from list: no OTP (AC story 122956). */
    public showDisconnectDialog(id: string) {
        this.disconnectShortCodeId = id;
        this.disconnectDialog = true;
    }

    public hideDisconnectDialog() {
        this.disconnectDialog = false;
        this.disconnectShortCodeId = '';
    }

    public async confirmDisconnect() {
        const id = this.disconnectShortCodeId;
        this.hideDisconnectDialog();
        const result = await this.shortService.disconnectShortCode(id);
        if (result && result.isSuccess) {
            Toaster.success(this.$t('shortPage.disconnectedSuccessfully').toString());
            await this.search();
        } else {
            const raw = result && result.errorMessage ? result.errorMessage : 'shared.errorOccurred';
            Toaster.error(this.$t(raw).toString());
        }
    }

    public async onDisconnectClick(id: string) {
        this.showDisconnectDialog(id);
    }

    public async updatePaginate(val: any) {
        const response = await this.shortService.get(this.filterModel.operator.toString(),
            this.filterModel.name, (val.page - 1).toString(), val.rowsPerPage);
        this.shorts = response.result;
        this.shortsCount = response.totalCount;
    }
    public sleep(ms: number) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    public hideOtpDialog() {

        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
            this.timerHandle = null;
        }

        this.otpDialog = false;
        this.otpCode = '';
        this.countDown = 0;
        this.data = '';
        this.otpExpiresAt = '';
    }

    public get formattedTime() {
        if (this.countDown <= 0) return "00:00";

        const minutes = Math.floor(this.countDown / 60);
        const seconds = this.countDown % 60;

        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    public countDownTimer() {
        if (this.timerHandle) {
            clearTimeout(this.timerHandle);
        }

        if (this.countDown > 0) {
            this.timerHandle = setTimeout(() => {
                this.countDown--;
                this.countDownTimer();
            }, 1000);
        }
    }

    async sendDeleteOtp() {
        const response = await this.shortService.sendDeleteOtp(this.shortCodeId);

        if (response.isSuccess) {
            this.data = response.data;
            this.otpExpiresAt = response.expiresAt;
            this.countDown = response.duration;
            this.otpDialog = true;
            this.countDownTimer();
        } else {
            const msg = this.$t(response.errorMessage).toString();
            Toaster.error(msg);
        }

    }

    public async resendOtp() {
        if (this.countDown > 0) {
            return;
        }
        await this.sendDeleteOtp();

    }
    public async verifyOtp() {

        if (this.otpCode.length !== 6) {
            return;
        }

        const result = await this.shortService.verifyDeleteOtp(
            this.data,
            this.otpExpiresAt,
            this.otpCode,
            this.shortCodeId
        );

        if (result.isSuccess) {
            this.hideOtpDialog();
            Toaster.success(this.$t('shortPage.deleteShortCodeSuccess').toString());
            await this.search();
        } else {
            const msg = this.$t(result.errorMessage).toString();
            Toaster.error(msg);
        }
    }

    public isNumberField(val: KeyboardEvent) {
        if (val.key && val.key.length === 1 && !/[0-9]/.test(val.key)) {
            val.preventDefault();
        }
    }

    public isNumberFieldPaste(ev: ClipboardEvent) {
        const paste = ev.clipboardData ? ev.clipboardData.getData('text') : '';
        if (paste && !/^\d+$/.test(paste)) {
            ev.preventDefault();
        }
    }

}
